query getCompaniesPostingInfo($input: CompaniesPostingInfoInput!) {
  getCompaniesPostingInfo(input: $input) {
    id
    name
    website
    landingpageUrl
    ambassador {
      firstname
      lastname
      image {
        url
      }
    }
    address {
      street
      city
      zip
      country
    }
    connectedSocialMediaTypes {
      facebook {
        id
        name
        isActive
        instagram_business_account {
          id
          username
          profile_picture_url
          isActive
        }
      }
      linkedin {
        name
        urn
        isActive
      }
      googleBusiness {
        status
        locationId
        locationName
      }
    }
  }
}
